import CheckboxCard from 'components/DesignSystem/CheckboxCard/CheckboxCard';
import { BillingPrice, BillingServiceName } from 'services/backend/billing';
import { getOptionPrice } from '../helpers';

interface SurveyDesignAndFieldingProps {
  surveyDetailsData: {
    ordering: number;
    label: string;
    value: BillingServiceName;
    tooltip: string;
    subtitle: string;
    isSelected: boolean;
    onToggle: () => void;
  }[];
  activePrices: BillingPrice[] | undefined;
  isLoadingBreakdown: boolean;
}

const SurveyDesignAndFielding = ({
  surveyDetailsData,
  activePrices,
  isLoadingBreakdown,
}: SurveyDesignAndFieldingProps) => {
  return (
    <div>
      <div>
        <p className="font-bold text-xl">Survey Design & Fielding</p>
        <p className="text-gray-500">
          Select the services you'd like Glass to provide. All are optional.
        </p>
      </div>
      {surveyDetailsData.map((service) => (
        <CheckboxCard
          key={`quote-tool-survey-design-checkbox-card-${service.ordering}`}
          cardLabel={service.label}
          cardSubtitle={service.subtitle}
          isLoading={isLoadingBreakdown}
          isSelected={service.isSelected}
          onClick={service.onToggle}
          price={getOptionPrice(service.value, activePrices)}
          toolTipText={service.tooltip}
        />
      ))}
    </div>
  );
};

export default SurveyDesignAndFielding;
